module.exports = __webpack_public_path__ + "img/cristian.26dc7d25.png";